export { default as InRestaurantRedemptionRewardList } from './reward-redemption-list';
